import { render, staticRenderFns } from "./bgColorImg.vue?vue&type=template&id=4e924c15&scoped=true&"
import script from "./bgColorImg.vue?vue&type=script&lang=js&"
export * from "./bgColorImg.vue?vue&type=script&lang=js&"
import style0 from "./bgColorImg.vue?vue&type=style&index=0&id=4e924c15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e924c15",
  null
  
)

export default component.exports